
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12 6.99999C12.55 6.99999 13 7.44999 13 7.99999V9.32999L20.2 16.53L20.71 16.02C20.9 15.83 21 15.58 21 15.31V8.67999C21 8.40999 20.89 8.15999 20.71 7.96999L16.03 3.28999C15.84 3.10999 15.58 2.99999 15.32 2.99999H8.68C8.42 2.99999 8.16 3.10999 7.98 3.28999L7.47 3.79999L11.16 7.48999C11.33 7.19999 11.64 6.99999 12 6.99999ZM2.41 1.57999L1 2.98999L4.64 6.62999L3.29 7.97999C3.11 8.15999 3 8.41999 3 8.67999V15.31C3 15.58 3.11 15.83 3.29 16.02L7.97 20.7C8.16 20.89 8.42 21 8.68 21H15.31C15.58 21 15.83 20.89 16.02 20.71L17.37 19.36L21.01 23L22.42 21.59L2.41 1.57999ZM12 17.3C11.28 17.3 10.7 16.72 10.7 16C10.7 15.28 11.28 14.7 12 14.7C12.72 14.7 13.3 15.28 13.3 16C13.3 16.72 12.72 17.3 12 17.3Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-report-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconReportOff

    ```js
    <b-new-b-icon-report-off />
    ```
</docs>


